import { useLayoutEffect, useState } from "react";
import { getRandomHeroUrl } from "services/RandomHero.service";

export default function useRandomCharacter() {
  const [image, setImage] = useState("");
  useLayoutEffect(() => {
    const url = getRandomHeroUrl();
    setImage(url);
  }, []);

  return image;
}
